var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTogglemenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 8.75122H4.6875C4.16973 8.75122 3.75 9.17095 3.75 9.68872C3.75 10.2065 4.16973 10.6262 4.6875 10.6262H25.3125C25.8303 10.6262 26.25 10.2065 26.25 9.68872C26.25 9.17095 25.8303 8.75122 25.3125 8.75122Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 14.0637H4.6875C4.16973 14.0637 3.75 14.4835 3.75 15.0012C3.75 15.519 4.16973 15.9387 4.6875 15.9387H21.5625C22.0803 15.9387 22.5 15.519 22.5 15.0012C22.5 14.4835 22.0803 14.0637 21.5625 14.0637Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 19.3738H4.6875C4.16973 19.3738 3.75 19.7935 3.75 20.3113C3.75 20.829 4.16973 21.2488 4.6875 21.2488H25.3125C25.8303 21.2488 26.25 20.829 26.25 20.3113C26.25 19.7935 25.8303 19.3738 25.3125 19.3738Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogglemenu);
export default __webpack_public_path__ + "static/media/togglemenu.022e4fd316d8cf77e3094a89e587dc45.svg";
export { ForwardRef as ReactComponent };